import { Reveal, Eyebrow } from "@/components/site/Reveal";

const STEPS = [
  ["01", "Nitric oxide", "A naturally occurring gas that helps blood vessels relax and expand — needed for achieving and maintaining an erection."],
  ["02", "cGMP", "The maker calls it the “manhood molecule”. The enzyme PDE5 breaks it down; the formula aims to help protect it."],
  ["03", "The formula", "One scoop a day of eight ingredients aimed at more nitric oxide, protected cGMP and healthy blood flow."],
];

export const NitricWhy = () => (
  <section id="why" className="bg-[#F2EDE4] py-24 sm:py-32" data-testid="nitric-why-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <Eyebrow className="!text-[#C62F2F]">How it's meant to work</Eyebrow>
        <h2 className="mt-5 max-w-2xl font-display text-4xl font-bold leading-[1.02] tracking-tight text-[#140A0C] sm:text-5xl">
          Three links in <span className="font-serif italic font-normal text-[#C62F2F]">one chain.</span>
        </h2>
      </Reveal>
      <div className="mt-14 grid grid-cols-1 gap-4 md:grid-cols-3">
        {STEPS.map(([n, t, d], i) => (
          <Reveal key={n} delay={i * 0.1} className="h-full">
            <div className="flex h-full flex-col justify-between rounded-[1.75rem] bg-[#140A0C] p-7 transition-transform duration-500 hover:-translate-y-1" data-testid={`nitric-why-${n}`}>
              <span className="font-display text-5xl font-extrabold text-[#FF4D4D]/30">{n}</span>
              <div className="mt-10">
                <h3 className="font-display text-2xl font-semibold text-[#F2EDE4]">{t}</h3>
                <p className="mt-3 text-sm leading-relaxed text-[#F2EDE4]/75">{d}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
